import React from 'react'
// components
import { Tab } from '@mui/material'
import { Tabs } from 'components/UI'
import { LoaderWithOverlay } from 'components/UI/Loader'
// constants
import { ENTITIES } from 'constants/index'
// context
import { KPIContext } from 'context/index'
// graphql
import { PLAN_KPI_ACTIVITIES_LIST_QUERY } from 'graphql/planKPIs/queries'
// hocs
import withKPI from 'components/Modals/PlanItems/KPI/withKPI'
// hooks
import { usePlanAccess } from 'hooks/index'
// view components
import ActivitiesListContainer from 'containers/Activities/components/ActivitiesList'
import CompleteReview from 'components/Modals/PlanItems/components/CompleteReview'
import DetailsSection from 'components/Modals/PlanItems/KPI/MinimizedModal/components/DetailsSection/index'
import KPIResultsList from 'components/Modals/PlanItems/KPI/MinimizedModal/components/KPIResultsList'
import KPIReviewsList from 'components/Modals/PlanItems/KPI/MinimizedModal/components/ReviewsList'
import ObjectivesListContainer from 'containers/ObjectivesList'
import AuthorizationWarning from 'components/UI/Warnings/AuthorizationWarning'
import QuickResultEnter from 'components/Modals/PlanItems/KPI/MinimizedModal/components/DetailsSection/components/QuickResultEnter'
// views
import { DetailsTab, FlexScrollbar, SubHeader } from 'components/Modals/PlanItems/styles'
import { ActivitiesWrapper } from 'components/Modals/CreateReviewModal/views'
// types
import { LogEntityTypes } from 'types/graphql'

const KPIDetails: React.FC = () => {
  const [tab, setTab] = React.useState(0)

  const { entity, isLoading, plan } = React.useContext(KPIContext) as any

  const shouldShowPlan = usePlanAccess(plan)

  const handleSetTab = (_, value) => setTab(value)

  return (
    <>
      <LoaderWithOverlay isLoading={isLoading} />
      {!isLoading && entity && (
        <>
          <SubHeader>
            <Tabs value={tab} onChange={handleSetTab} indicatorColor='primary' textColor='primary' variant={null}>
              <Tab label='Details' />
              <Tab label='Plan' />
              <Tab label='Activity' />
              <Tab label='Results' />
              <Tab label='Reviews' />
            </Tabs>
          </SubHeader>
          {tab === 0 && (
            <DetailsTab>
              <QuickResultEnter isFullModal={false} />
              <CompleteReview entity={{ ...entity, entityType: ENTITIES.PLAN_KPI }} />
              <FlexScrollbar>
                <DetailsSection entity={{ ...entity, entityType: LogEntityTypes.Kpi }} />
              </FlexScrollbar>
            </DetailsTab>
          )}

          {tab === 2 && (
            <ActivitiesWrapper>
              <ActivitiesListContainer
                entity={{ ...entity, entityType: LogEntityTypes.Kpi }}
                query={PLAN_KPI_ACTIVITIES_LIST_QUERY}
                variables={{
                  filter: { entityId: entity.id }
                }}
              />
            </ActivitiesWrapper>
          )}

          <div style={{ height: 'calc(100% - 50px)' }}>
            {tab === 1 && (shouldShowPlan ? <ObjectivesListContainer plan={plan} /> : <AuthorizationWarning />)}
            {tab === 3 && <KPIResultsList />}
            {tab === 4 && <KPIReviewsList />}
          </div>
        </>
      )}
    </>
  )
}

export default withKPI(KPIDetails)
